<div class="container-fluid p-0" *ngIf="flagLogin">
  <div class="row no-gutters">
    <div class="col-sm-12 bg-light p-0 m-0 position-relative">
      <div class="bg-light">
        <div class="btn-viettel fixed-header text-white p-4 text-center">
          {{ selectedText }}
        </div>
      </div>
      <div
        class="authentication-page-content p-4 d-flex align-items-center min-vh-100"
      >
        <div class="w-100">
          <div class="row justify-content-center">
            <div class="col-sm-12">
              <div>
                <div class="text-center">
                  <div>
                    <img
                      src="assets/images/logo_qrpaybox-bup.png"
                      width="140"
                      alt="logo"
                    />
                  </div>
                  <h4 class="font-size-18 mt-4 text-uppercase">
                    {{'Giải Pháp Thanh Toán QR' | translate}}
                  </h4>
                  <p class="text-muted">
                    {{'Xác nhận để tiếp tục sử dụng' | translate}}
                  </p>
                </div>
                <div class="p-2 mt-4">
                  <div class="mt-4 text-center">
                    <button
                      class="btn btn-viettel col-12"
                      (click)="handleLinkClick()"
                    >
                      {{'Tạo liên kết' | translate}}
                    </button>
                  </div>
                  <!-- <div class="text-center mt-2">
                    <button
                      (click)="toLogin()"
                      class="btn btn-outline-danger waves-effect waves-light col-12"
                    >
                      {{'Đăng nhập bằng tài khoản' | translate}}
                    </button>
                  </div> -->
                </div>
              </div>
            </div>
            <div class="text-center mt-3">
              <p>
                Giải pháp thanh toán QR toàn diện nhất. Tự động đọc thông báo
                khi Khách hàng thanh toán thành công, giảm tối đa rủi ro khi
                thanh toán chuyển khoản
              </p>
            </div>
            <!-- <div class="text-center mt-1">
                            <p class="text-center text-muted">Hotline <a class="font-weight-bold text-success" href="tel:1900599822">1900 599 822</a> (1500đ/phút)</p>
                        </div> -->
            <div class="text-center mt-3">
              <h6 class="text-center font-weight-bold text-muted">
                Đối tác độc quyền:
                <span class="font-weight-bold text-primary"> TOMOTEK JSC </span>
                <!-- Đại lý độc quyền:>
                <span class="font-weight-bold text-danger"
                  >Viettel &#64; Tomotek</span
                > -->
              </h6>
            </div>
            <div
              class="d-flex justify-content-center px-4 mt-4 pb-5"
              (click)="onBack()"
            >
              <button class="btn w-100 btn-outline-danger">
                Đóng ứng dụng
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
